import { FormRangeNumberModel } from './form-range-number';
import { RANGE_SLIDER_MAX_VALUE, RANGE_SLIDER_MIN_VALUE, RangeSliderValue } from './range-slider';

export class FormRangeNumberUtils {
    static prepareModel(value: FormRangeNumberModel, minExtreme: number, maxExtreme: number): FormRangeNumberModel {
        if (!value) {
            return { from: minExtreme, to: maxExtreme };
        }
        let from = value.from;
        if (isNaN(from) || from < minExtreme) {
            from = minExtreme;
        }
        if (from > maxExtreme) {
            from = maxExtreme;
        }
        let to = value.to;
        if (isNaN(to) || to > maxExtreme) {
            to = maxExtreme;
        }
        if (to < minExtreme) {
            to = minExtreme;
        }

        return { from, to };
    }

    /**
     * Tranformiert die Werte vom Schieberegler nach folgenden Aufgabenbereich (min - max)
     */
    static sliderValueToNumber(value: RangeSliderValue, minExtreme: number, maxExtreme: number,
                               fraction: number): FormRangeNumberModel {
        const sliderRange = maxExtreme - minExtreme;
        const from = FormRangeNumberUtils.round(sliderRange * (value.from / 100) + minExtreme, fraction);
        const to = FormRangeNumberUtils.round(sliderRange * (value.to / 100) + minExtreme, fraction);
        return {
            from: isNaN(from) ? minExtreme : from,
            to: isNaN(to) ? minExtreme : to
        };
    }

    static numberToSliderValue(value: FormRangeNumberModel, minExtreme: number, maxExtreme: number): RangeSliderValue {
        const sliderRange = maxExtreme - minExtreme;
        const from = Math.round((value.from - minExtreme) / sliderRange * 100);
        const to = Math.round((value.to - minExtreme) / sliderRange * 100);
        return {
            from: isNaN(from) ? RANGE_SLIDER_MIN_VALUE : from,
            to: isNaN(to) ? RANGE_SLIDER_MAX_VALUE : to
        };
    }

    private static round(num: number, fraction: number): number {
        if (fraction === 0) {
            return Math.round(num);
        }
        return Number(num.toFixed(fraction));
    }
}
